/// <amd-module name="Wit/WorkItemModel/Services/IWorkItemFieldEventService" />
import { IVssObservableService, Services, VssObservableService } from "VSS/Platform/Context";
import { IWorkItem, WorkItemChangeType } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export interface IWorkItemFieldEventData {
    workItem: IWorkItem;
    fieldDefinitionIds?: number[];
    workItemChangeType?: WorkItemChangeType;
    setByRules?: boolean;
}

export enum IWorkItemFieldEventType {
    WorkItemFieldsUpdated = "WorkItemFieldsUpdated",
}

type IWorkItemEvent = keyof typeof IWorkItemFieldEventType;

/**
 * Service used by WorkItem.ts to signal changes in a work item instance to any subscribers.
 */
export interface IWorkItemFieldEventService extends IVssObservableService<IWorkItemFieldEventData, IWorkItemEvent> {
    fireEvent(eventData: IWorkItemFieldEventData, eventType: IWorkItemFieldEventType): void;
}

class WorkItemFieldEventService extends VssObservableService<IWorkItemFieldEventData, IWorkItemEvent> implements IWorkItemFieldEventService {
    public fireEvent(eventData: IWorkItemFieldEventData, eventType: IWorkItemFieldEventType) {
        this._notify(eventData, eventType);
    }
}

const serviceName = "IWorkItemFieldEventService";
Services.add(serviceName, { serviceFactory: WorkItemFieldEventService });
